import React from "react";
import PropTypes from "prop-types";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import Loader from "../../../general/Loader";
import "./ExtensionDeletionConfirmation.css";

const ExtensionDeletionConfirmation = ({
    visible,
    extension,
    isProcessing,
    error,
    onConfirm,
    onCancel,
}) => {
    if (!extension) return null;

    return (
        <Dialog
            header="Confirm Deletion"
            visible={visible}
            style={{ width: "400px" }}
            onHide={onCancel}
            modal
            dismissableMask
            className="extension-deletion-confirmation"
        >
            {isProcessing && <Loader />}

            <p>
                Are you sure you want to delete the extension:{" "}
                <strong>{extension.extensionName}</strong>?
            </p>
            {error && <div className="error-message">{error}</div>}

            <div className="confirmation-actions">
            <Button
                    label="Cancel"
                    icon="pi pi-times"
                    className="p-button-secondary"
                    onClick={onCancel}
                    disabled={isProcessing}
                />
                <Button
                    label="Delete"
                    icon="pi pi-trash"
                    className="p-button-danger"
                    onClick={onConfirm}
                    disabled={isProcessing}
                    autoFocus
                />
               
            </div>
        </Dialog>
    );
};

ExtensionDeletionConfirmation.propTypes = {
    visible: PropTypes.bool.isRequired,
    extension: PropTypes.object,
    isProcessing: PropTypes.bool,
    error: PropTypes.string,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default ExtensionDeletionConfirmation;